import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Campaign from './Campaign';

const Campaigns = ({ location, campaigns, onPreview }) => {
  let marginTop = 0;
  let marginLeft = 0;

  switch (location) {
    case 'wa': {
      marginTop = 150;
      marginLeft = 25;
      break;
    }
    case 'nt': {
      marginTop = 50;
      marginLeft = 180;
      break;
    }
    case 'sa': {
      marginTop = 190;
      marginLeft = 190;
      break;
    }
    case 'qld': {
      marginTop = 85;
      marginLeft = 290;
      break;
    }
    case 'nsw': {
      marginTop = 230;
      marginLeft = 315;
      break;
    }
    case 'vic': {
      marginTop = 290;
      marginLeft = 310;
      break;
    }
    case 'tas': {
      marginTop = 355;
      marginLeft = 330;
      break;
    }
    case 'act': {
      marginTop = 300;
      marginLeft = 350;
      break;
    }
    default: {
      console.log('Unrecognised location', location);
    }
  }

  return (
    <Container
      marginTop={marginTop}
      marginLeft={marginLeft}
    >
      {campaigns.map(({ id, campaignName }) => (
        <Campaign
          onPreview={onPreview(id)}
          campaignName={campaignName}
        />
      ))}
    </Container>
  );
};

export default Campaigns;

Campaigns.propTypes = {
  location: PropTypes.string.isRequired,
  campaigns: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  onPreview: PropTypes.func.isRequired,
};

const Container = styled.div`
  position: absolute;
  margin-top: ${props => props.marginTop}px;
  margin-left: ${props => props.marginLeft}px;
`;




// WEBPACK FOOTER //
// ./client/Dashboard/components/Campaigns.js